package com.milta.feature.route.domain.usecase

import com.milta.feature.route.domain.entity.RouteBatchDispatchResult
import com.milta.feature.route.domain.repository.RouteRepository

/** POST /api/v1/route-batches/{id}/dispatch (MIL-39). */
class DispatchRouteBatchUseCase(private val repository: RouteRepository) {
    suspend operator fun invoke(batchId: String): RouteBatchDispatchResult = repository.dispatchRouteBatch(batchId)
}
